import { motion } from "framer-motion";
import Layout from "@/components/Layout";
import PageHero from "@/components/PageHero";
import aboutHero from "@/assets/about-hero.jpg";
import SEO from "@/components/SEO";

const OurStory = () => {
  return (
    <Layout>
      <SEO title="Our Story | Vaughan McLean" description="Learn about Vaughan McLean's legacy of excellence in litigation and advisory law, serving clients across the United States for decades." />
      <PageHero backgroundImage={aboutHero} title="Our Story" subtitle="About the Firm" />

      <section className="section-dark py-24">
        <div className="container mx-auto px-8 lg:px-16">
          <div className="max-w-3xl">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <h2 className="font-heading text-4xl font-light text-foreground mb-8">
                Our Story
              </h2>
              <p className="text-muted-foreground font-body leading-relaxed mb-6">
                For decades, esteemed attorney Joseph Vaughan has endeavored to provide his clients with exceptional legal representation. Joe has assembled teams of skilled, experienced attorneys and para-professionals to offer focused, practical, innovative and creative legal guidance. Joe is confident this approach to providing legal services enhances the firm's ability to serve its clients.
              </p>
              <p className="text-muted-foreground font-body leading-relaxed mb-6">
                The attorneys of Vaughan McLean are accustomed to representing a diverse clientele, from local businesses to Fortune 500 companies that span the globe. In every case, they uphold their commitment to excellence, diligence and creativity. Few teams are more experienced in helping clients to overcome complex legal challenges and achieve their goals inside and outside of the courtroom.
              </p>
              <p className="text-muted-foreground font-body leading-relaxed">
                Vaughan McLean adheres to a mission of superb legal service. The attorneys who have earned your trust through the years can now offer you even greater resources in its growing areas of practice, which are the attorneys who specialize in each practice area. Though the firm is excited to evolve, rest assured its foundation remains dedication to its valued clients.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section-card py-24 border-t border-border">
        <div className="container mx-auto px-8 lg:px-16">
          <p className="text-xs tracking-[0.3em] uppercase font-body text-primary mb-4">Our Values</p>
          <h2 className="font-heading text-4xl font-light text-foreground mb-16">What Guides Us</h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {[
              {
                title: "Integrity",
                desc: "We hold ourselves to the highest ethical standards in every matter we handle.",
              },
              {
                title: "Excellence",
                desc: "We pursue outstanding results through meticulous preparation and innovative thinking.",
              },
              {
                title: "Commitment",
                desc: "We are deeply invested in our clients' success and dedicated to their goals.",
              },
            ].map((value, i) => (
              <motion.div
                key={value.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.15 }}
                viewport={{ once: true }}
                className="border-l-2 border-primary pl-6"
              >
                <h3 className="font-heading text-2xl text-foreground mb-3">{value.title}</h3>
                <p className="text-muted-foreground font-body text-sm leading-relaxed">{value.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default OurStory;
